// Number / date / verdict formatting helpers
import { formatDistanceToNow, parseISO } from "date-fns";

export const verdictColor = (v) =>
    v === "good"
        ? "#34C759"
        : v === "caution"
          ? "#FFCC00"
          : v === "avoid"
            ? "#FF3B30"
            : "#7a7a7a";

export const verdictBg = (v) =>
    v === "good"
        ? "bg-[#34C759]"
        : v === "caution"
          ? "bg-[#FFCC00]"
          : v === "avoid"
            ? "bg-[#FF3B30]"
            : "bg-zinc-200";

export const verdictLabel = (v) =>
    v === "good" ? "Good" : v === "caution" ? "Caution" : v === "avoid" ? "Avoid" : "—";

export function fmtCurrency(amount, currency = "EUR") {
    if (amount === null || amount === undefined) return "—";
    try {
        return new Intl.NumberFormat("en-EU", {
            style: "currency",
            currency,
            minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
            maximumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        }).format(amount);
    } catch (e) {
        return `${currency} ${amount}`;
    }
}

export function fmtMileage(km, unit) {
    if (km === null || km === undefined) return "—";
    return `${Math.round(km).toLocaleString()} ${unit ?? "km"}`;
}

export function fmtRelative(iso) {
    if (!iso) return "—";
    try {
        return formatDistanceToNow(parseISO(iso), { addSuffix: true });
    } catch (e) {
        return iso;
    }
}

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        return parseISO(iso).toLocaleDateString();
    } catch {
        return iso;
    }
}

export function fmtNumber(n) {
    if (n === null || n === undefined) return "—";
    return Number(n).toLocaleString();
}

export const FUEL_TYPES = ["diesel", "petrol", "hybrid", "electric", "lpg", "cng"];
export const TRANSMISSIONS = ["manual", "automatic"];
export const VERDICTS = ["good", "caution", "avoid"];
export const SORT_FIELDS = [
    { value: "date", label: "Date" },
    { value: "score", label: "Score" },
    { value: "price", label: "Price" },
    { value: "mileage", label: "Mileage" },
    { value: "year", label: "Year" },
    { value: "make", label: "Make" },
];

export const PACKAGES = {
    starter: { credits: 5, price: 1.99, currency: "EUR", per: 0.4 },
    standard: { credits: 15, price: 4.99, currency: "EUR", per: 0.33 },
    hunter: { credits: 40, price: 9.99, currency: "EUR", per: 0.25 },
};
